import { TalkToJonButton } from "@/components/talk-to-jon";
import { OFFER } from "@/lib/site-content";

/**
 * Opening section: the claim, one line of context and the action.
 */
export function Hero() {
  return (
    <section
      id="top"
      aria-labelledby="hero-h"
      className="relative mx-auto max-w-[1400px] px-5 pb-32 pt-[calc(env(safe-area-inset-top)+14rem)] sm:px-6 md:px-10 md:pb-36 md:pt-[17rem]"
    >
      <h1
        id="hero-h"
        className="font-display max-w-[16ch] text-balance text-[clamp(2.25rem,4.8vw,4rem)] leading-[1.0] tracking-[-0.04em]"
      >
        From idea to live product in {OFFER.days} days.
      </h1>
      <p className="mt-6 max-w-[46ch] text-pretty text-lg leading-snug text-muted-foreground md:text-xl">
        Websites and web apps, designed and built to a studio standard by one team of full-stack
        designers. For companies that need to prove it fast and scale it faster.
      </p>
      <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-4 md:mt-10">
        <TalkToJonButton variant="dark" immersive />
      </div>
    </section>
  );
}
